import { Tenancy_Rich_Asset_Type_Enum_Ps_Enum } from '@pypestream/api-services';

type AssetTypeItem = {
  type: Tenancy_Rich_Asset_Type_Enum_Ps_Enum;
};

const ASSET_ORDER: Tenancy_Rich_Asset_Type_Enum_Ps_Enum[] = [
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.None,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Buttons,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Button,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.QuickReply,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Listpicker,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Selection,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Carousel,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Imagebutton,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Webview,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Image,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Png,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Video,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Document,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.FileUpload,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Datepicker,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Location,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Star,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Secure,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.PersistentMenu,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Audio,
] as const;

const REMOVED_ASSETS = new Set<Tenancy_Rich_Asset_Type_Enum_Ps_Enum>([
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Timepicker,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.LoginButton,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Deeplink,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Nav,
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum.Utterances,
]);

const ASSET_PRIORITY: Record<Tenancy_Rich_Asset_Type_Enum_Ps_Enum, number> =
  ASSET_ORDER.reduce(
    (acc, type, index) => {
      acc[type] = index;
      return acc;
    },
    {} as Record<Tenancy_Rich_Asset_Type_Enum_Ps_Enum, number>
  );

const sortAssetsByType = <
  T extends { type: Tenancy_Rich_Asset_Type_Enum_Ps_Enum },
>(
  assets: readonly T[]
): T[] => {
  return assets
    .filter((asset) => !REMOVED_ASSETS.has(asset.type))
    .slice()
    .sort((a, b) => {
      const aPriority = ASSET_PRIORITY[a.type] ?? Number.MAX_SAFE_INTEGER;
      const bPriority = ASSET_PRIORITY[b.type] ?? Number.MAX_SAFE_INTEGER;

      return aPriority - bPriority;
    });
};

export const ASSET_LABELS: Record<
  Tenancy_Rich_Asset_Type_Enum_Ps_Enum,
  string
> = {
  none: 'None',
  buttons: 'Buttons',
  button: 'Button (Legacy)',
  quick_reply: 'Quick Reply (Legacy)',
  listpicker: 'List Picker',
  selection: 'Selection (Legacy)',
  carousel: 'Carousel',
  imagebutton: 'Image Button',
  webview: 'Web View',
  image: 'Image',
  png: 'PNG (Legacy)',
  video: 'Video',
  document: 'Document',
  file_upload: 'File Upload',
  datepicker: 'Date Picker',
  location: 'Location',
  star: 'Stars',
  secure: 'Secure Input',
  persistent_menu: 'Persistent Menu',
  audio: 'Audio (Voice only)',

  // Not used, but enum requires them
  deeplink: 'Deep Link',
  timepicker: 'Time Picker',
  login_button: 'Login Button',
  nav: 'Nav',
  utterances: 'Utterances',
};

export const getAssetLabelByType = (
  type: Tenancy_Rich_Asset_Type_Enum_Ps_Enum
) => {
  return ASSET_LABELS[type];
};

export const getAssetTypeList = () => {
  const rawAssets: AssetTypeItem[] = Object.values(
    Tenancy_Rich_Asset_Type_Enum_Ps_Enum
  ).map((type) => ({
    type,
  }));

  const sortedAssets = sortAssetsByType(rawAssets);

  return sortedAssets.map(({ type }) => ({
    type,
    label: ASSET_LABELS[type],
  }));
};
